import React, { useState, useEffect, useRef } from "react";

// Custom SVG icons to replace react-icons
const FaSearch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
    width="1em"
    height="1em"
  >
    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c77.3 0 144-49.8 144-144s-66.7-144-144-144S64 120.7 64 208s66.7 144 144 144z"></path>
  </svg>
);
const FaHtml5 = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.3h175.9l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-60.2H12l7.7 82.5L192 434.4l162.7-54L356 261.2h-180l-2.1-22.3h185.5l-7.2-73.4H103.5l-5.2-57.5H308.2z"></path>
  </svg>
);
const FaJava = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M312.3 216c-13.5-3.3-27.1-5.7-41-6.8-15.6-1.2-31.5-1.7-47.5-1.7-33.1 0-63 8.3-88.7 24.5-25.5 16-45 38.6-58.4 67.8-13.4 29.2-20.1 63.8-20.1 103.8v69c0 10.3 8.4 18.7 18.7 18.7h54.7c10.3 0 18.7-8.4 18.7-18.7V426c0-10.4-8.4-18.7-18.7-18.7H136c-10.3 0-18.7-8.4-18.7-18.7V342c0-50.6 12.8-90.4 38.3-120.6 25.5-30.2 59.9-45.3 103.4-45.3 15 0 29.8.5 44.5 1.5 24.5 1.6 43.1 8.2 55.8 20.3 12.7 12 19 28.5 19 49.5 0 20.7-6.2 37.1-18.5 49.4s-28.7 18.5-49.4 18.5c-20.8 0-37.5-6.2-50.2-18.5-12.7-12.2-19-28.8-19-49.5 0-16.1 4-29.4 11.9-40.1 7.9-10.8 17.5-18.3 28.8-22.6-3.8-6.1-9.9-10.7-18.3-13.7s-18.3-4.5-29.3-4.5c-11.4 0-21.7 1.1-31 3.2-9.3 2.1-17.5 5-24.5 8.7-6.9 3.7-12.3 8.3-16.1 13.9-3.8 5.6-5.8 11.8-5.8 18.6 0 16.7 5.7 29.8 17.2 39.4 11.5 9.6 26.6 14.4 45.3 14.4 10.2 0 19.3-1 27.2-3.1s14.8-5.1 20.4-8.6l3.5-.7c-4.4 14.2-11.2 26.7-20.4 37.5-9.2 10.8-20.7 19.4-34.5 25.8-13.8 6.5-28.9 9.7-45.3 9.7-19.3 0-36.9-3.9-52.7-11.8-15.8-7.9-28.8-19.7-39-35.4-10.2-15.7-15.3-33.8-15.3-54.3v-49.4c0-20.8 6.5-39.7 19.5-56.9 13-17.2 30.7-30.8 53-40.7 22.2-9.9 46.8-14.8 74-14.8 24.2 0 46.1 3.4 65.7 10.1 19.6 6.7 34.6 15.5 45.2 26.4s16.2 24.3 16.2 39.9c0 10.5-2 19.4-6.1 26.8s-9.9 13.1-17.2 17.3c21.8 14.7 39.4 33.7 52.8 57.1s20.1 48.9 20.1 76.5c0 29-7 54.1-20.9 75.3-13.9 21.2-33.2 38.3-57.8 51.3s-52.9 19.5-84.5 19.5c-29.3 0-56.1-5.6-80.4-16.8-24.3-11.2-43.9-27.1-58.8-47.8-14.9-20.7-22.3-44.8-22.3-72.2V166.7c0-10.3-8.4-18.7-18.7-18.7H18.7C8.4 148 0 156.4 0 166.7V256c0 10.3 8.4 18.7 18.7 18.7h54.7c10.3 0 18.7-8.4 18.7-18.7v-25c0-10.3-8.4-18.7-18.7-18.7H18.7c-10.3 0-18.7-8.4-18.7-18.7V148H0V96.7c0-10.3 8.4-18.7 18.7-18.7h54.7c10.3 0 18.7-8.4 18.7-18.7V27.4c0-10.3-8.4-18.7-18.7-18.7H18.7C8.4 8.7 0 17.1 0 27.4V96h.7c0 0 .7 0 1.4 0H27.4c10.3 0 18.7 8.4 18.7 18.7V224h18.7c10.3 0 18.7 8.4 18.7 18.7v45.3c0 10.3-8.4 18.7-18.7 18.7h-18.7v32H136.7c10.3 0 18.7 8.4 18.7 18.7V426c0 10.3-8.4 18.7-18.7 18.7H18.7c-10.3 0-18.7 8.4-18.7 18.7V502c0 10.3 8.4 18.7 18.7 18.7h54.7c10.3 0 18.7-8.4 18.7-18.7v-38.6c0-10.3-8.4-18.7-18.7-18.7H18.7c-10.3 0-18.7 8.4-18.7 18.7v45.3h.7c0 0 .7 0 1.4 0H312.3c10.3 0 18.7-8.4 18.7-18.7V234.7c0-10.3-8.4-18.7-18.7-18.7z"></path>
  </svg>
);
const FaDatabase = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M448 32C482.7 32 512 59.3 512 94v64c0 34.7-29.3 64-64 64H64c-34.7 0-64-29.3-64-64V94c0-34.7 29.3-64 64-64H448zM240 192a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM448 256c34.7 0 64 29.3 64 64v64c0 34.7-29.3 64-64 64H64c-34.7 0-64-29.3-64-64V320c0-34.7 29.3-64 64-64H448zM240 416a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"></path>
  </svg>
);
const FaAws = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M608 238.4l-112-64v-86.4L320 0 3.2 110.8v290.4L320 512l288-164.8V238.4zM320 288c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32s32 14.3 32 32v112c0 17.7-14.3 32-32 32zm0 160c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32zm0-256c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 17.7-14.3 32-32 32z"></path>
  </svg>
);
const FaReact = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M528 288c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM112 288c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM320 0C143.2 0 0 143.2 0 320s143.2 320 320 320 320-143.2 320-320S496.8 0 320 0zm0 576c-132.5 0-240-107.5-240-240s107.5-240 240-240 240 107.5 240 240-107.5 240-240 240z"></path>
  </svg>
);
const FaCuttlefish = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M416 32h-32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM32 32H0c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM128 128h-32c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32zM288 128h-32c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32z"></path>
  </svg>
);
const FaJsSquare = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M448 32H0V512H448V32zM365.3 221.7c-7.9 14-22.4 23.5-38.3 23.5-12.2 0-21.7-6.5-26.7-19.5-.7-1.8-1.5-3.6-2.2-5.4-3.5-8.7-7.2-16.7-11.4-23.7s-10.1-12.7-17-15.6c-7-2.9-15.5-4.4-25.5-4.4-17.9 0-32.9 5.8-44.8 17.4-11.9 11.6-17.9 27.6-17.9 48.2s6 36.6 17.9 48.2c11.9 11.6 26.9 17.4 44.8 17.4 12.5 0 24.3-2 35.3-6.1-4.7 11.4-12.5 20.3-23.3 26.8-10.8 6.5-22.8 9.7-36.1 9.7-25.2 0-45.7-9.3-61.6-28-15.9-18.7-23.8-42.3-23.8-70.8s7.9-52.1 23.8-70.8c15.9-18.7 36.4-28.1 61.6-28.1 19.3 0 35.5 5.2 48.7 15.6s21.5 24.5 25.5 41.5z"></path>
  </svg>
);
const SiSpringboot = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M256 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zM192 144c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V176c0-17.7-14.3-32-32-32zM320 144c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V176c0-17.7-14.3-32-32-32zM448 352c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32zM64 352c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"></path>
  </svg>
);
const SiCplusplus = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    fill={color}
    width="1em"
    height="1em"
  >
    <path d="M448 32H0V512H448V32zM365.3 221.7c-7.9 14-22.4 23.5-38.3 23.5-12.2 0-21.7-6.5-26.7-19.5-.7-1.8-1.5-3.6-2.2-5.4-3.5-8.7-7.2-16.7-11.4-23.7s-10.1-12.7-17-15.6c-7-2.9-15.5-4.4-25.5-4.4-17.9 0-32.9 5.8-44.8 17.4-11.9 11.6-17.9 27.6-17.9 48.2s6 36.6 17.9 48.2c11.9 11.6 26.9 17.4 44.8 17.4 12.5 0 24.3-2 35.3-6.1-4.7 11.4-12.5 20.3-23.3 26.8-10.8 6.5-22.8 9.7-36.1 9.7-25.2 0-45.7-9.3-61.6-28-15.9-18.7-23.8-42.3-23.8-70.8s7.9-52.1 23.8-70.8c15.9-18.7 36.4-28.1 61.6-28.1 19.3 0 35.5 5.2 48.7 15.6s21.5 24.5 25.5 41.5z"></path>
  </svg>
);

// Custom SVG icons for Hibernate, MyBatis, and Tomcat
const HibernateIcon = ({ size = 80, color = "#d4b68f" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="256" height="256" fill="none"></rect>
    <path
      d="M128,24V232"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    ></path>
    <path
      d="M96,64h64"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    ></path>
    <path
      d="M96,192h64"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    ></path>
    <path
      d="M64,96h128"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    ></path>
    <path
      d="M64,160h128"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    ></path>
    <path
      d="M208,128c0,48-32,88-80,88S48,176,48,128,80,40,128,40,208,80,208,128Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    ></path>
  </svg>
);

const MyBatisIcon = ({ size = 80, color = "#d4b68f" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224,224-100.3,224-224S379.7,32,256,32ZM256,432c-97.2,0-176-78.8-176-176S158.8,80,256,80s176,78.8,176,176-78.8,176-176,176Z"
      fill={color}
    ></path>
    <path
      d="M256,200c-30.9,0-56,25.1-56,56s25.1,56,56,56,56-25.1,56-56S286.9,200,256,200Zm0,80c-13.2,0-24-10.8-24-24s10.8-24,24-24,24,10.8,24,24S269.2,280,256,280Z"
      fill={color}
    ></path>
    <path
      d="M360,256c0,57.4-46.6,104-104,104s-104-46.6-104-104,46.6-104,104-104,104,46.6,104,104ZM256,184c-39.7,0-72,32.3-72,72s32.3,72,72,72,72-32.3,72-72S295.7,184,256,184Z"
      fill={color}
    ></path>
  </svg>
);

const TomcatIcon = ({ size = 80, color = "#d4b68f" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M256,32c-88.4,0-160,71.6-160,160S167.6,352,256,352,416,280.4,416,192,344.4,32,256,32Zm0,288c-70.6,0-128-57.4-128-128S185.4,64,256,64s128,57.4,128,128S326.6,320,256,320Z"
      fill={color}
    ></path>
    <path
      d="M256,320c-17.7,0-32,14.3-32,32s14.3,32,32,32,32-14.3,32-32S273.7,320,256,320Z"
      fill={color}
    ></path>
    <path
      d="M256,384c-17.7,0-32,14.3-32,32s14.3,32,32,32,32-14.3,32-32S273.7,384,256,384Z"
      fill={color}
    ></path>
    <path
      d="M192,448c-17.7,0-32,14.3-32,32s14.3,32,32,32,32-14.3,32-32S209.7,448,192,448Z"
      fill={color}
    ></path>
    <path
      d="M320,448c-17.7,0-32,14.3-32,32s14.3,32,32,32,32-14.3,32-32S337.7,448,320,448Z"
      fill={color}
    ></path>
    <path
      d="M416,320c-17.7,0-32,14.3-32,32s14.3,32,32,32,32-14.3,32-32S433.7,320,416,320Z"
      fill={color}
    ></path>
    <path
      d="M96,320c-17.7,0-32,14.3-32,32s14.3,32,32,32,32-14.3,32-32S113.7,320,96,320Z"
      fill={color}
    ></path>
  </svg>
);

const courses = [
  {
    name: "HTML",
    link: "https://www.w3schools.com/html/",
    icon: <FaHtml5 color="#d4b68f" />,
  },
  {
    name: "Java",
    link: "https://www.w3schools.com/java/",
    icon: <FaJava color="#d4b68f" />,
  },
  {
    name: "Spring Boot",
    link: "https://spring.io/projects/spring-boot",
    icon: <SiSpringboot color="#d4b68f" />,
  },
  {
    name: "MySQL",
    link: "https://www.mysql.com/",
    icon: <FaDatabase color="#d4b68f" />,
  },
  {
    name: "AWS",
    link: "https://aws.amazon.com/",
    icon: <FaAws color="#d4b68f" />,
  },
  {
    name: "React",
    link: "https://react.dev/",
    icon: <FaReact color="#d4b68f" />,
  },
  {
    name: "C",
    link: "https://www.iso.org/standard/74528.html",
    icon: <FaCuttlefish color="#d4b68f" />,
  },
  {
    name: "C++",
    link: "https://isocpp.org/",
    icon: <SiCplusplus color="#d4b68f" />,
  },
  {
    name: "JavaScript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    icon: <FaJsSquare color="#d4b68f" />,
  },
  {
    name: "Hibernate",
    link: "https://hibernate.org/",
    icon: <HibernateIcon />,
  },
  {
    name: "MyBatis",
    link: "https://mybatis.org/mybatis-3/",
    icon: <MyBatisIcon />,
  },
  {
    name: "Apache Tomcat",
    link: "https://tomcat.apache.org/",
    icon: <TomcatIcon />,
  },
];

const CoursesInfo = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);

  const filteredCourses = courses.filter((course) =>
    course.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  return (
    <div
      style={{
        backgroundColor: '#f0f4f8', // Light background
        fontFamily: 'sans-serif',
        position: 'relative',
        overflow: 'hidden',
        padding: '6rem 1rem',
        minHeight: '100vh',
      }}
    >
      {/* Main Content Container */}
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          color: '#334155', // Dark text color
        }}
      >
        <h1
          style={{
            color: '#1f2937', // Solid dark color
            fontSize: '2.5rem',
            fontWeight: 700,
            lineHeight: 1.2,
            marginBottom: '40px',
            fontFamily: 'serif',
          }}
        >
          Explore Our <span style={{ color: '#d4b68f' }}>Tech Stack</span>
        </h1>

        <div
          style={{
            position: 'relative',
            width: '100%',
            maxWidth: '500px',
            margin: '0 auto 40px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#ffffff', // Light background
            borderRadius: '25px',
            padding: '8px 15px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)', // Subtle shadow
            border: '1px solid #e2e8f0', // Light border
          }}
        >
          <div
            style={{
              color: '#d4b68f',
              fontSize: '1.4em',
              padding: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            aria-label="Search"
          >
            <FaSearch />
          </div>
          <input
            type="text"
            placeholder="Search technologies..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flexGrow: 1,
              padding: '10px 15px',
              border: 'none',
              background: 'transparent',
              color: '#1f2937', // Dark text color
              fontSize: '1.1em',
              outline: 'none',
              paddingLeft: '10px',
            }}
            aria-label="Technology search input"
            ref={searchInputRef}
          />
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '30px',
            padding: '20px',
            justifyContent: 'center',
            backgroundColor: '#f1f5f9', // Light grid background
            borderRadius: '10px',
            boxShadow: '0 10px 20px rgba(0,0,0,0.1)', // Lighter shadow
          }}
        >
          {filteredCourses.length > 0 ? (
            filteredCourses.map((course) => (
              <a
                key={course.name}
                href={course.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: '#ffffff', // White card background
                  border: '1px solid #e2e8f0', // Light border
                  borderRadius: '12px',
                  padding: '25px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)', // Subtle initial shadow
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  textDecoration: 'none',
                  color: '#334155', // Dark text color
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.1)'; // Lighter hover shadow
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.05)';
                }}
              >
                <div style={{
                  width: '80px',
                  height: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '10px',
                }}>
                  {course.icon}
                </div>
                <h3
                  style={{
                    color: '#d4b68f',
                    fontSize: '1.8em',
                    marginBottom: '8px',
                    fontWeight: '600',
                    letterSpacing: '0.5px',
                    margin: '0',
                  }}
                >
                  {course.name}
                </h3>
              </a>
            ))
          ) : (
            <p
              style={{
                gridColumn: '1 / -1',
                textAlign: 'center',
                fontSize: '1.5em',
                color: '#475569', // Dark text
                padding: '50px',
                backgroundColor: '#ffffff', // White background
                borderRadius: '10px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Lighter shadow
              }}
            >
              No technologies found matching your search.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoursesInfo;